import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import _ from 'lodash';
import { adminFetchStudentMissions, } from '../../services/pstudentMissions.service';
import MDEditor from '@uiw/react-md-editor';

const isMobile = window.innerWidth < 1024;
function Component(props) {
    const { id } = useParams();
    const navigate = useNavigate();
    const [mission, setmission] = useState(null)
    const [isLoading, setisLoading] = useState(false)

    const fetchMission = async () => {
        let result = await adminFetchStudentMissions(props.token.token, { _id: id });
        if (result.result) {
            setmission(result.result?.[0] || null)
        } else {
            alert('Fetch data error')
        }
    }

    const refresh = async () => {
        if (isLoading) return
        setisLoading(true)
        await fetchMission()
        setisLoading(false)
    }

    useEffect(() => {
        refresh()
    }, [id])


    return (
        <div className='relative h-full flex-1 bg-[#F2F2F2] flex-col flex text-[16px] text-[black]' style={{ overflowY: "auto" }}>
            <div className='flex flex-row items-center justify-between items-center gap-[8px] flex-wrap px-[16px] pt-[16px] mb-[8px]'>
                <div className='text-[#1D1D41] text-[24px] font-[400] cursor-pointer' onClick={() => { navigate(`/platform/studentmissions/${mission?._id}`) }}>{`<`} 返回</div>
            </div>

            <div className='w-full flex flex-row items-center justify-start items-center gap-[8px] flex-wrap p-[16px] font-[700]'>
                <div className='flex-1 min-w-[300px]'>閲讀任務名稱: {mission?.name}</div>
                <div className='flex-1 min-w-[300px]'>學校名稱: {mission?.school?.name}</div>
                <div className='flex-1 min-w-[300px]'>學生姓名: {mission?.student?.name}</div>
                <div className='flex-1 min-w-[300px]'>學生班級: {mission?.student?.class}</div>
                <div className='flex-1 min-w-[300px]'>學生性別: {mission?.student?.gender}</div>
                <div className='flex-1 min-w-[300px]'>問卷開始時間: {mission?.questionnaire2StartTime ? new Date(mission.questionnaire2StartTime).toLocaleString() : ''}</div>
                <div className='flex-1 min-w-[300px]'>問卷完成時間: {mission?.questionnaire2FinishTime ? new Date(mission.questionnaire2FinishTime).toLocaleString() : ''}</div>
            </div>


            {!mission?.questionnaire2FinishTime &&
                <div className='flex-1 flex justify-center items-center px-[64px]'>
                    <div className='text-[#1D1D41] text-[24px] font-[400]'>問卷未完成</div>
                </div>
            }
            <div className='flex flex-col p-[16px] w-full'>
                {mission?.questionnaire2FinishTime && mission?.questionnaires2?.map((questionnaire, index) =>
                    <div key={questionnaire.id || index} className='w-full mb-[64px]' style={{}}>
                        <div className='font-[700] mt-[16px]'>問題 {index + 1}</div>
                        {['短句作答題'].includes(questionnaire.type) || <MDEditor.Markdown source={questionnaire?.question || ''} style={{ fontSize: isMobile ? 16 : 25, whiteSpace: 'pre-wrap', color: "black", backgroundColor: "transparent" }} />}
                        {['選擇題', '選擇題 + 短句作答題'].includes(questionnaire.type) &&
                            <div className='w-full mt-[16px] flex flex-col items-start gap-[16px]'>
                                {questionnaire?.options?.map((option, optionIndex) => (
                                    <div key={optionIndex} className='flex flex-row gap-[8px] items-center'>
                                        <div className='flex bg-[#ddd] rounded-full p-[1px]'>
                                            <button onClick={() => { }}
                                                className={`w-[20px] h-[20px] rounded-full border-[5px] border-[#fafafa] ${option.isSelected ? 'bg-blue-500' : 'bg-[#fafafa]'}`}
                                            ></button>
                                        </div>
                                        {option.text}
                                    </div>
                                ))}
                            </div>
                        }
                        {['短句作答題', '選擇題 + 短句作答題'].includes(questionnaire?.type) && (
                            <div className='w-fill mt-[16px] flex flex-col p-[2px]'>
                                <MDEditor.Markdown source={questionnaire?.questionShortanswer || ''} style={{ fontSize: isMobile ? 16 : 25, whiteSpace: 'pre-wrap', color: "black", backgroundColor: "transparent" }} />
                                <textarea
                                    className='w-full flex flex-col p-[16px] bg-[#F8F8F8] gap-[8px] rounded-[2px] mt-[16px]' style={{ border: '1px solid #00000080', boxShadow: '0px 0px 2px 2px rgb(217,229,193)' }}
                                    value={questionnaire?.answer || ''}
                                    onChange={(e) => { }}
                                />
                            </div>
                        )}
                        {/*end of open end question*/}

                        {['表格問題'].includes(questionnaire?.type) &&
                            <div className='w-fill mt-[16px] flex flex-col p-[2px] gap-[16px]'>
                                <div className='w-full flex flex-row gap-[16px]'>
                                    <div className='flex-1 max-w-[150px]'>
                                    </div>
                                    {questionnaire?.options?.map((option, optionIndex) =>
                                        <div key={optionIndex} className='flex-1 flex justify-center items-center max-w-[150px]'>
                                            <div>{option?.text}</div>
                                        </div>
                                    )}
                                </div>
                                {questionnaire?.rows?.map((row, rowIndex) =>
                                    <div key={rowIndex} className='w-full flex flex-row gap-[16px]'>
                                        <div className='flex-1 max-w-[150px]'>
                                            {row?.text}
                                        </div>
                                        {questionnaire?.options?.map((option, optionIndex) =>
                                            <div key={optionIndex} className='flex-1 flex justify-center items-center max-w-[150px]'>
                                                <button onClick={() => { }}
                                                    className={`w-[20px] h-[20px] rounded-full border-[1px] border-[black] ${row?.answer === optionIndex ? 'bg-gray-500' : 'bg-[#fafafa]'}`}
                                                ></button>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        }

                    </div>
                )}
            </div>

        </div>
    )

}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Component)
